import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import animated from 'animate.css'
Vue.use(animated)

Vue.config.productionTip = false

router.afterEach((to) => {
  if (to) {
    store.state.selected = to.name
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
